'use client';

import {Button} from '@chakra-ui/button';
import {Flex, Heading, Text} from '@linx-security/ui';
import {usePathname, useRouter, useSearchParams} from 'next/navigation';
import {useEffect} from 'react';

import {LoginError} from './_lib/errors';

const LoginErrorPage = ({error, reset}: {error: LoginError | Error; reset: () => void}) => {
  const message = error instanceof LoginError ? error.data?.message : `Something went wrong`;
  const recoverable = error instanceof LoginError ? error.data?.isRecoverable : false;
  const recoveryMessage = error instanceof LoginError ? error.data?.recoveryMessage : undefined;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const errorParam = searchParams?.get(`error`);

  useEffect(() => {
    if (!errorParam) {
      // Rerender login UI
      reset();
    }
  }, [errorParam, reset]);

  const handleReset = () => {
    if (pathname) {
      // Remove the error param from the URL
      router.replace(pathname);
    }
  };

  return (
    <Flex direction={`column`} alignItems={`center`} minH={`180px`}>
      <Heading size={`lg`}>{message}</Heading>
      {recoveryMessage && (
        <Text size={`md`} variant={`secondary`}>
          {recoveryMessage}
        </Text>
      )}

      {recoverable && (
        <Button variant={`link`} onClick={handleReset} mt={`24`}>
          Try again
        </Button>
      )}
    </Flex>
  );
};

export default LoginErrorPage;
